import React from 'react';
import {IdpAdminEventLogList} from "components/idp-admin-event-log/IdpAdminEventLogList";
import {Provider} from "components/idp-admin-event-log/IdpAdminEventLogContext";

export const IdpAdminEventLogs = () => {

    return (
        <Provider>
            <IdpAdminEventLogList/>
        </Provider>
    );
}
